import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { navItems, siteInfo } from "@/mocks/site";

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header className="sticky top-0 z-50 w-full">
      <div className="hidden w-full bg-foreground-950 text-background-100 md:block">
        <div className="mx-auto flex w-full max-w-[1240px] items-center justify-between px-6 py-2 text-xs">
          <p className="flex items-center gap-2">
            <span className="flex h-3.5 w-3.5 items-center justify-center text-accent-400" aria-hidden="true">
              <i className="ri-radar-line text-[13px] animate-pulse-dot" />
            </span>
            持续更新中 · 追踪社会爆料反转与官方回应
          </p>
          <div className="flex items-center gap-5">
            <span className="flex items-center gap-1.5 text-background-300">
              <i className="ri-mail-line text-sm" aria-hidden="true" />
              {siteInfo.email}
            </span>
            <span className="text-background-400">最后更新 2026-09-10</span>
          </div>
        </div>
      </div>

      <div
        className={`w-full border-b transition-all duration-300 ${
          scrolled
            ? "border-background-200 bg-background-50/95 shadow-[0_1px_0_0_rgba(0,0,0,0.03)] backdrop-blur"
            : "border-transparent bg-background-50"
        }`}
      >
        <div className="mx-auto flex w-full max-w-[1240px] items-center justify-between px-4 py-3 md:px-6 md:py-4">
          <Link to="/" className="flex items-center gap-2.5" aria-label={`${siteInfo.fullName} 首页`}>
            <span className="relative flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-white">
              <i className="ri-focus-3-line text-lg" aria-hidden="true" />
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">
                棱镜求证
              </span>
              <span className="mt-0.5 text-[10px] uppercase tracking-[0.25em] text-foreground-500">
                PRISM&nbsp;VERIFY
              </span>
            </span>
          </Link>

          <nav aria-label="主导航" className="hidden items-center gap-1 lg:flex">
            {navItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.path === "/"}
                className={({ isActive }) =>
                  `relative rounded-md px-3.5 py-2 text-sm font-medium transition-colors ${
                    isActive
                      ? "text-primary-600"
                      : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                  }`
                }
              >
                {({ isActive }) => (
                  <>
                    {item.label}
                    {isActive ? (
                      <span className="absolute inset-x-3.5 -bottom-0.5 h-[2px] rounded-full bg-primary-500" aria-hidden="true" />
                    ) : null}
                  </>
                )}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <Link
              to="/cases"
              className="hidden items-center gap-1.5 rounded-md border border-background-300 px-3.5 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 sm:inline-flex"
            >
              <i className="ri-search-line text-base" aria-hidden="true" />
              <span className="whitespace-nowrap">查事件</span>
            </Link>
            <Link
              to="/about#contact"
              className="hidden items-center gap-1.5 rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-primary-600 md:inline-flex"
            >
              <i className="ri-send-plane-line text-base" aria-hidden="true" />
              <span className="whitespace-nowrap">提交线索</span>
            </Link>
            <button
              type="button"
              onClick={() => setOpen((v) => !v)}
              aria-expanded={open}
              aria-label={open ? "关闭菜单" : "打开菜单"}
              className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-800 transition-colors hover:bg-background-100 lg:hidden"
            >
              <i className={`${open ? "ri-close-line" : "ri-menu-3-line"} text-xl`} aria-hidden="true" />
            </button>
          </div>
        </div>

        {open ? (
          <div className="border-t border-background-200 bg-background-50 lg:hidden">
            <nav aria-label="移动端导航" className="mx-auto flex w-full max-w-[1240px] flex-col px-4 py-3 md:px-6">
              {navItems.map((item) => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  end={item.path === "/"}
                  className={({ isActive }) =>
                    `flex items-center justify-between rounded-md px-3 py-3 text-sm font-medium transition-colors ${
                      isActive
                        ? "bg-primary-50 text-primary-700"
                        : "text-foreground-700 hover:bg-background-100"
                    }`
                  }
                >
                  {item.label}
                  <i className="ri-arrow-right-s-line text-base text-foreground-400" aria-hidden="true" />
                </NavLink>
              ))}
              <Link
                to="/about#contact"
                className="mt-3 flex items-center justify-center gap-2 rounded-md bg-primary-500 px-4 py-3 text-sm font-semibold text-white"
              >
                <i className="ri-send-plane-line text-base" aria-hidden="true" />
                提交线索
              </Link>
            </nav>
          </div>
        ) : null}
      </div>
    </header>
  );
}